import React, { useState, useContext } from "react";
import { Card, CardHeader, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { LanguageContext } from "App";

import AccountingApi from "../../../Classes/API/AccountingApi";
import GetContractReportReq from "Classes/Models/Requests/Accounting/GetContractReportReq";
import { downloadContractReportExcel } from "../ContractExcelExport"; 
import DateRangePopup from "../ContractDetails/DateRangePopup";

const ContractDetailsCard = ({
  Contract,
  setShowSessions,
  ShowSessions,
  setShowAddPatients,
  ShowAddPatients,
}) => {
  const { translations } = useContext(LanguageContext);
  const [showDatePopup, setShowDatePopup] = useState(false);

  const getContractReport = async (id, startDate = null, endDate = null) => {
    const req = new GetContractReportReq();
    req.ContractId = id;
    if (startDate) req.Date.StartDate = startDate;
    if (endDate) req.Date.EndDate = endDate;

    const res = await AccountingApi.GetContractReport(req);
    downloadContractReportExcel(res);
  };

  return (
    <Card
      sx={{
        boxShadow: "none",
        mb: 4,
        p: 3,
        borderRadius: "12px",
        border: "1px solid #ddd",
      }}
    >
      <CardHeader
        title={translations.ContractInfo}
        sx={{ mb: 1, textAlign: "start" }}
      />

      <div className="row p-3" style={{ rowGap: "10px" }}>
        <div className="col-md-4">
          <MDTypography variant="button" fontWeight="bold">
            {translations.ContractInfoName}:
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Contract.name}
          </MDTypography>
        </div>

        <div className="col-md-4">
          <MDTypography variant="button" fontWeight="bold">
            {translations.ContractInfoDescription}:
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Contract.description}
          </MDTypography>
        </div>

        <div className="col-md-4">
          <MDTypography variant="button" fontWeight="bold">
            {translations.ContractInfoCreatedAt}:
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Contract.timeStamp.split("T")[0]}
          </MDTypography>
        </div>

        <div className="col-md-4">
          <MDTypography variant="button" fontWeight="bold">
            {translations.ContractInfoShowSessions}:
          </MDTypography>
          <MDBox sx={{ display: "inline-block", ml: 1 }}>
            <Switch checked={ShowSessions} onChange={() => setShowSessions(!ShowSessions)} />
          </MDBox>
        </div>

        <div className="col-md-4">
          <MDTypography variant="button" fontWeight="bold">
            {translations.ContractInfoShowPatients}:
          </MDTypography>
          <MDBox sx={{ display: "inline-block", ml: 1 }}>
            <Switch
              checked={ShowAddPatients}
              onChange={() => setShowAddPatients(!ShowAddPatients)}
            />
          </MDBox>
        </div>

        <div className="col-md-4">
          <button
            className="btn btn-outline-primary w-100"
            onClick={() => setShowDatePopup(true)}
          >
            {translations.contactsDownloadDetails || "Download Report"}
          </button>
        </div>
      </div>

      <DateRangePopup
        open={showDatePopup}
        onClose={() => setShowDatePopup(false)}
        onConfirm={async (start, end) => {
          await getContractReport(Contract.id, start, end);
          setShowDatePopup(false);
        }}
      />
    </Card>
  );
};

export default ContractDetailsCard;
